import React from 'react';
import { User, Scale, Ruler } from 'lucide-react';

/**
 * Компонент с секцией персональных параметров (пол, возраст, вес, рост)
 */
const PersonalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Пол */}
      <div className="col-span-full">
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Пол
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label className="inline-flex items-center justify-center p-3 rounded-lg border cursor-pointer transition-colors
            ${formData.gender === 'male' 
            ? 'bg-emerald-50 border-emerald-300 text-emerald-700 dark:bg-emerald-900/30 dark:border-emerald-700 dark:text-emerald-300'
            : 'bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600'
            }">
            <input
              type="radio"
              name="gender"
              value="male"
              checked={formData.gender === 'male'}
              onChange={handleInputChange}
              className="sr-only"
            />
            <div className="flex flex-col items-center">
              <span className="text-xl mb-1">👨</span>
              <span className="font-medium">Мужской</span>
            </div>
          </label>
          <label className="inline-flex items-center justify-center p-3 rounded-lg border cursor-pointer transition-colors
            ${formData.gender === 'female' 
            ? 'bg-emerald-50 border-emerald-300 text-emerald-700 dark:bg-emerald-900/30 dark:border-emerald-700 dark:text-emerald-300'
            : 'bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600'
            }">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={formData.gender === 'female'}
              onChange={handleInputChange}
              className="sr-only"
            />
            <div className="flex flex-col items-center">
              <span className="text-xl mb-1">👩</span>
              <span className="font-medium">Женский</span>
            </div>
          </label>
        </div>
        {errors.gender && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.gender}
          </p>
        )}
      </div>

      {/* Возраст */}
      <div>
        <label htmlFor="age" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <User className="w-4 h-4 mr-2 text-emerald-500" />
          Возраст (лет)
        </label>
        <input
          type="number"
          id="age"
          name="age"
          value={formData.age}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.age ? 'input-error' : ''}`}
          placeholder="Введите возраст"
          min="1"
          max="120"
        />
        {errors.age && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.age}
          </p>
        )}
      </div>

      {/* Вес */}
      <div>
        <label htmlFor="weight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Scale className="w-4 h-4 mr-2 text-emerald-500" />
          Вес (кг)
        </label>
        <input
          type="number"
          id="weight"
          name="weight"
          value={formData.weight}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.weight ? 'input-error' : ''}`}
          placeholder="Введите вес"
          min="20"
          max="350"
          step="0.1"
        />
        {errors.weight && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.weight}
          </p>
        )}
      </div>

      {/* Рост */}
      <div>
        <label htmlFor="height" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Ruler className="w-4 h-4 mr-2 text-emerald-500" />
          Рост (см)
        </label>
        <input
          type="number"
          id="height"
          name="height"
          value={formData.height}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.height ? 'input-error' : ''}`}
          placeholder="Введите рост"
          min="100"
          max="250"
        />
        {errors.height && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.height}
          </p>
        )}
      </div>
    </div>
  );
};

export default PersonalParametersSection;